import { withSvgIcon } from './withSvgIcon';

export const CreditCardWithdraw = withSvgIcon(
  <path
    d="M20 18.5H5C3.89543 18.5 3 17.6046 3 16.5V7.5C3 6.39543 3.89543 5.5 5 5.5H19C20.1046 5.5 21 6.39543 21 7.5V13M20 18.5L17 15.5M20 18.5L17 21.5M7 14.5H8M3 9.83333H21"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="square"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 24 24' },
);
